












































































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Id from "@/components/inputs/Id.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import Select35 from "@/components/inputs/Select35.vue";
import {ActionsEnum} from "@/entity/ActionsEnum";
import {UsersEntity} from "@/entity/UsersEntity";
import OrderTotals from "@/components/OrderTotals.vue";
interface userPermissionType{
    user_permission_type_id:number,
    name:string
}
interface userPermissions{
    "user_permission_id": "1",
    "user_id": null,
    "page": "Categories",
    "get": "0",
    "post": "0",
    "patch": "0",
    "delete": "0",
    "copy": "0",
    "created_at": null,
    "updated_at": null
}
@Component({
    components: {
        OrderTotals,
        DeleteButton,EForm,Id,EnabledSwitch,Number,TextField,Select35
    }
})
export default class Users extends  Vue{
    items : UsersEntity[] | null = null;
    dialog = false;
    title:string = "";
    search: string = "";
    baseAction:string = ActionsEnum.Users;
    brokenAdminId:number = 3;
    action:string = this.baseAction;
    userPermissionAction:string = "userPermission";
    data : UsersEntity = new UsersEntity();
    userPermissionTypes : userPermissionType[] = []
    userOrderTotals!:any;
    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "user_id"
        },
        {text: "Ad", value: "name"},
        {text: "Soyad", value: "lastname"},
        {text: "Cinsiyet", value: "gender"},
        {text: "E-Posta", value: "email"},
        {text: "Oluşturulma", value: "created_at"},
        {text: "İşlemler", value: "actions"}
    ];
    permissionHeaders = [
        {text: "Sayfa", value: "page"},
        {text: "Gösterme", value: "get"},
        {text: "Ekleme / Düzenleme", value: "post"},
        {text: "Değiştirme", value: "patch"},
        {text: "Silme", value: "delete"},
        {text: "Kopyalama", value: "copy"},
    ]
    permissionItems : userPermissions[] = [];
    permissionSearch : string = "";
    async getUserPermissions(userId:number){
        let response =  await this.$http.post(this.userPermissionAction+"/"+userId);
        this.permissionItems = response.data;
    }
    async getUserOrderTotals(){
        let request = {
            status: 0,
            status_condition:"!=",
            user_id:this.data.user_id,
            all_dates:true
        }
        let response = await Vue.prototype.$http.request({
            method:"POST",
            responseType:"json",
            data:JSON.stringify(request),
            transformRequest:[function (data:any, headers:any) {
                return data;
            }],
            url:"report"
        });
        this.userOrderTotals = response.data;
    }
    async edit(item:UsersEntity){
        await this.getUserOrderTotals();
        await this.changePermissionType();
        this.title = "Düzenle";
        this.data = item;
        this.action = this.baseAction + "/" + item.user_id;
        this.dialog = true;
    }
    async changePermissionType(){
        //console.log(this.data.user_permission_type_id);
        if(this.data.user_permission_type_id == this.brokenAdminId){ //Kısıtlı admin 3
            if(this.data.user_id == 0){
                alert("Lütfen önce üyeyi ekleyiniz yetki işlemlerini daha sonra tamamlayınız.");
                return;
            }
            this.getUserPermissions(this.data.user_id);
        }
    }
    add(){
        this.title = "Ekle";
        this.action = this.baseAction;
        this.data = new UsersEntity();
        this.dialog = true;
    }
    async getUserPermissionTypes(){
        let response = await this.$http.get("userPermissionTypes");
        this.userPermissionTypes = response.data;
    }
    async get(){
        this.dialog = false;
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
    }
    created(){
        this.get();
        this.getUserPermissionTypes();
    }
};
